import { Link } from "react-router-dom";
import { UserRound } from "lucide-react";
import LogoMark from "@/components/LogoMark";
import { useAuth } from "@/context/AuthContext";

export default function BrandHeader({ compact = false }) {
  const { user } = useAuth();
  return <header className={`flex items-center justify-between ${compact ? "mb-6" : "mb-9"}`} aria-label="UnAnonymous">
    <Link to="/home" className="flex items-center gap-2 text-[11px] sm:text-[12px] uppercase tracking-[0.36em] font-medium" style={{ color: "var(--un-text-2)", fontFamily: "Manrope, sans-serif" }}><LogoMark size={28} title=""/>UnAnonymous</Link>
    <Link to={user ? "/account" : "/auth?mode=signin"} aria-label={user ? "Open account" : "Sign in"} className="h-11 px-3 rounded-full flex items-center gap-2 justify-center un-press" style={{ background: "rgba(91,57,84,0.07)", color: "var(--un-plum-deep)", border: "1px solid rgba(91,57,84,0.06)" }}><UserRound size={19} strokeWidth={1.7}/><span className="text-[10px] font-medium sm:hidden">{user ? "Account" : "Sign in"}</span></Link>
  </header>;
}
